'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 36px;\n  min-height: 36px;\n  max-height: 36px;\n  background: ', ';\n  display: flex;\n  align-items: center;\n  padding: 0px 6px;\n'], ['\n  width: 100%;\n  height: 36px;\n  min-height: 36px;\n  max-height: 36px;\n  background: ', ';\n  display: flex;\n  align-items: center;\n  padding: 0px 6px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-size: 12px;\n  line-height: 24px;\n  padding: 0px 10px;\n  border-radius: 12px;\n  background: ', ';\n  flex: 1;\n  display: block;\n  margin: 0px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: transparent;\n  font-family: inherit;\n\n  transition: border-color 0.3s ease-in-out;\n\n  &:focus {\n    outline: none;\n    border-color: ', ';\n  }\n'], ['\n  width: 100%;\n  font-size: 12px;\n  line-height: 24px;\n  padding: 0px 10px;\n  border-radius: 12px;\n  background: ', ';\n  flex: 1;\n  display: block;\n  margin: 0px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: transparent;\n  font-family: inherit;\n\n  transition: border-color 0.3s ease-in-out;\n\n  &:focus {\n    outline: none;\n    border-color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 50%;\n  background: ', ';\n  font-size: 14px;\n  margin-left: 6px;\n  text-align: center;\n  color: ', ' !important;\n  cursor: pointer;\n'], ['\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  border-radius: 50%;\n  background: ', ';\n  font-size: 14px;\n  margin-left: 6px;\n  text-align: center;\n  color: ', ' !important;\n  cursor: pointer;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, _colors.grey);

var UrlBar = _styledComponents2.default.input(_templateObject2, _colors.white, _colors.blue);

var Close = _styledComponents2.default.div(_templateObject3, _colors.red, _colors.white);

var Bar = function Bar(_ref) {
  var src = _ref.src,
      onClose = _ref.onClose;
  return _react2.default.createElement(Container, null, _react2.default.createElement(UrlBar, {
    value: src || '',
    onChange: function onChange(e) {
      return e.preventDefault();
    }
  }), _react2.default.createElement(Close, {
    onClick: onClose
  }, _react2.default.createElement(_Icon2.default, {
    icon: 'close'
  })));
};

Bar.propTypes = {
  src: _propTypes2.default.string,
  onClose: _propTypes2.default.func
};
exports.default = Bar;